export type SendRequestEventLocation = 'head' | 'end' | 'main' | '1' | '2' | '3' | '4' | '5';

export const gtmLanguageMapping = {
  'RU': 'rus',
  'EN': 'eng',
  'ES': 'esp',
};
